import type { PlatformBridge, PlatformType, PlatformUser, ShareParams, ThemeColors } from './types.ts';

const DEFAULT_THEME: ThemeColors = {
  bgColor: '#ffffff',
  textColor: '#1a1a1a',
  hintColor: '#888888',
  linkColor: '#2563eb',
  buttonColor: '#16a34a',
  buttonTextColor: '#ffffff',
  secondaryBgColor: '#f3f4f6',
};

export class MockBridge implements PlatformBridge {
  getPlatform(): PlatformType {
    return 'mock';
  }

  getUser(): PlatformUser {
    return {
      id: 1,
      firstName: 'Тест',
      lastName: 'Пользователь',
      username: 'testuser',
      phone: '+79991234567',
    };
  }

  getInitData(): string {
    return 'mock_init_data';
  }

  async requestPhone(): Promise<string | null> {
    return '+79991234567';
  }

  showBackButton(): void {
    console.log('[MockBridge] showBackButton');
  }

  hideBackButton(): void {
    console.log('[MockBridge] hideBackButton');
  }

  onBackButtonClick(cb: () => void): void {
    console.log('[MockBridge] onBackButtonClick registered', cb);
  }

  impactOccurred(style: 'light' | 'medium' | 'heavy'): void {
    console.log('[MockBridge] impactOccurred:', style);
  }

  getTheme(): ThemeColors {
    return DEFAULT_THEME;
  }

  ready(): void {
    console.log('[MockBridge] ready');
  }

  close(): void {
    console.log('[MockBridge] close');
  }

  openLink(url: string): void {
    console.log('[MockBridge] openLink:', url);
  }

  openMaxLink(url: string): void {
    console.log('[MockBridge] openMaxLink:', url);
  }

  async share(_params: ShareParams): Promise<'shared' | 'cancelled'> {
    console.log('[MockBridge] share called');
    return 'cancelled';
  }

  enableClosingConfirmation(): void {
    console.log('[MockBridge] enableClosingConfirmation');
  }

  disableClosingConfirmation(): void {
    console.log('[MockBridge] disableClosingConfirmation');
  }
}
